export enum ResultValueType {
  Edit1 = "EDIT1",
  String4 = "STR,4",
  String3 = "STR,3",
  Culture = "CULTURE",
  String = "STR",
  String5 = "STR,5",
  LST = "LST",
  String20 = "STR,20",
  Integer = "INT",
}
